import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { DashboardComponent } from "./dashboard.component";

const routes: Routes = [
  {
    path: "",
    component: DashboardComponent,
    data: {
      title: "Dashboard",
    },
    children: [
      {
        path: "rgvsi",
        data: {
          title: "RGVSI",
        },
        loadChildren: () => import("../RGVSI/Dashboard/dashboard.module").then((m) => m.DashboardModule),
      },
      {
        path: "salud",
        data: {
          title: "Salud",
        },
        loadChildren: () => import("../SaludLocal/Dashboard/dashboard.module").then((m) => m.DashboardModule),
      },
      {
        path: "afi",
        data: {
          title: "AFI",
        },
        loadChildren: () =>
          import("../AFI/PersonalCustomerDashboard/personal-customer-dashboard.module").then(
            (m) => m.PersonalCustomerDashboardModule
          ),
      },
    ],
  },
  {
    path: "agentes",
    children: [
      {
        path: "salud",
        loadComponent: () =>
          import("../SaludLocal/AgentsDashboard/agents-dashboard.component").then((c) => c.AgentsDashboardComponent),
      },
      {
        path: "rgvsi",
        loadComponent: () =>
          import("../RGVSI/AgentsDashboard/agents-dashboard.component").then((c) => c.AgentsDashboardComponent),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule {}
